import React, { useState, useEffect } from "react";
import { Col, Label, Row, Input, Table } from "reactstrap";
import logo from "../../../assets/images/logo-hoz_black.png";
import moment from "moment";
import PriceUtils from "../../../helpers/PriceUtils";
import { reduce } from "lodash";
import CalcUtils from "../../../helpers/CalcUltils"
const List = (props: any) => {
  const { data, componentRef, detailDes } = props;
  const [dataPrint, setDataPrint] = useState<any>()
  const [dataInfor, setDataInfor] = useState<any>({})

  useEffect(() => {
    setData()
  },[data])

  const setData = () => {
    if (data?.length > 1 || data?.length == 1) {
      const Arr: any = [];
      data?.map((item: any) => {
        Arr.push(item)
      })
      setDataPrint(Arr)
      setDataInfor(detailDes)
      return
    }
    let ArrDataPrint: any = []
    data?.designation_services?.map((item: any) => {
      ArrDataPrint.push(item)
    })
    setDataPrint(ArrDataPrint)
    setDataInfor(data)
  }

  const getFullAddressHeader = () => {
    const address = [
      dataInfor?.branch_id?.street,
      dataInfor?.branch_id?.wards_code?.name,
      dataInfor?.branch_id?.district_code?.name,
      dataInfor?.branch_id?.provinces_code?.name,
    ];
    return address?.filter((e: any) => e != null)?.join(", ");
  };

  const getFullAddress = () => {
    const address: any[] = [
      dataInfor?.customer_id?.street,
      dataInfor?.customer_id?.wards_code?.name,
      dataInfor?.customer_id?.district_code?.name,
      dataInfor?.customer_id?.provinces_code?.name,
    ];

    if (address.length > 0) {
      return address?.filter((e: any) => e != null && e !== "")?.join(", ");
    } else {
      return "---";
    }
  };
  
  const date = () => {
    const year = moment().format("YYYY");
    const month = moment().format("MM");
    const day = moment().format("DD");
    return `Ngày ${day} tháng ${month} năm ${year}`;
  };

  const total = reduce(
    dataPrint,
    (prev: any, item: any) => {
      if (item?.service_id?.price) {
        prev += ((item?.service_id?.price * item?.service_quantity) - (item?.service_discount * item?.service_quantity));
      }
      return prev;
    },
    0
  );

  const PrintContent = () => {
    return (
      <div>
        <div className="header__print" style={{ marginTop: 30, borderBottom: "1px dashed #000000" }}>
          <div className="header__logo">
            <img src={logo} alt="" height="100" />
          </div>
          <div className="header__content">
            <div className="item">
              <Label className="value-text title" style={{ fontSize: "18px" }}>
                Phòng khám dinh dưỡng nhi Dr.Nutri
              </Label>
            </div>
            <div className="item">
              <Label>Địa chỉ:</Label>
              <div className="value-text">{getFullAddressHeader()}</div>
            </div>
            <div className="item d-flex">
              <div className="d-flex">
                <Label>Điện thoại:</Label>
                <div className="value-text">
                  {dataInfor?.branch_id?.hotline ? dataInfor?.branch_id?.hotline : ""}
                </div>
              </div>
              <div className="d-flex" style={{ marginLeft: 230 }}>
                <Label style={{ width: 80 }}>Email:</Label>
                <div className="value-text">
                  {dataInfor?.branch_id?.email ? dataInfor?.branch_id?.email : ""}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="content__print">
          <div
            style={{
              paddingBottom: 15,
              marginBottom: 15,
            }}
          >
            <div
              style={{
                textAlign: "center",
                fontSize: "36px",
                fontWeight: "600",
                color: "#000000",
                marginTop: "20px",
                marginBottom: "15px",
              }}
            >
              PHIẾU THU DỊCH VỤ
            </div>
            <div>
              <p style={{ color: "#000000", textAlign: "center" }}>{date()}</p>
            </div>
            <div className="p-5 info-box">
              <div className="item">
                <Row>
                  <Col md={6} xs={12}>
                    <div className="item-sub">
                      <Label>Khách hàng:</Label>
                      <div className="value-text">
                        {dataInfor?.customer_id?.name ? dataInfor?.customer_id?.name : ""}
                      </div>
                    </div>
                  </Col>
                  <Col md={6} xs={12}>
                    <div className="item-sub">
                      <Label>Mã khách hàng:</Label>
                      <div className="value-text">
                        {dataInfor?.customer_id?.code ? dataInfor?.customer_id?.code : ""}
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
              <div className="item">
                <Row>
                  <Col md={6} xs={12}>
                    <div className="item-sub">
                      <Label>Tuổi:</Label>
                      <div className="value-text">
                        {CalcUtils.calculateAge(dataInfor?.customer_id?.birthday)}
                      </div>
                    </div>
                  </Col>
                  <Col md={6} xs={12}>
                    <div className="item-sub">
                      <Label>Số điện thoại:</Label>
                      <div className="value-text">
                        {dataInfor?.customer_id?.phone ? dataInfor?.customer_id?.phone : "---"}
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
              <div className="item">
                {dataInfor?.customer_id?.customer_guardians?.length > 0 && (
                  <Row>
                    <Col md={6} xs={12}>
                      <div className="item-sub">
                        <Label>Người bảo hộ:</Label>
                        <div className="value-text">{dataInfor?.customer_id?.customer_guardians?.[0]?.name}</div>
                      </div>
                    </Col>
                    <Col md={6} xs={12}>
                      <div className="item-sub">
                        <Label>CMT/CCCD:</Label>
                        <div className="value-text">{dataInfor?.customer_id?.customer_guardians?.[0]?.cccd}</div>
                      </div>
                    </Col>
                  </Row>
                )}

              </div>
              <div className="item">
                <Row>
                  <Col md={12} xs={12}>
                    <div className="item-sub">
                      <Label>Địa chỉ:</Label>
                      <div className="value-text">{getFullAddress()}</div>
                    </div>
                  </Col>
                </Row>
              </div>
              <div className="item">
                <Row>
                  <Col md={6} xs={12}>
                    <div className="item-sub">
                      <Label>Hình thức thanh toán:</Label>
                      <div className="value-text">
                        {dataInfor?.designation_payments?.[0]?.payment_method_id?.name
                          ? dataInfor?.designation_payments?.[0]?.payment_method_id
                            ?.name
                          : "---"}
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
              <Table responsive style={{ marginTop: 20 }}>
                <thead style={{ backgroundColor: "#F4F6F8" }}>
                  <tr style={{ fontWeight: "bold", fontSize: "25px" }}>
                    <td
                      style={{
                        padding: 12,
                        fontSize: 21,
                        fontWeight: "bold",
                        color: "#000000",
                      }}
                    >
                      STT
                    </td>
                    <td
                      style={{
                        padding: 12,
                        fontSize: 21,
                        fontWeight: "bold",
                        color: "#000000",
                        textAlign: "start",
                        maxWidth: 300
                      }}
                    >
                      Nội dung
                    </td>
                    <td
                      style={{
                        padding: 12,
                        fontSize: 21,
                        fontWeight: "bold",
                        color: "#000000",
                      }}
                    >
                      ĐVT
                    </td>
                    <td
                      style={{
                        padding: 12,
                        fontSize: 21,
                        fontWeight: "bold",
                        color: "#000000",
                      }}
                    >
                      SL
                    </td>
                    <td
                      style={{
                        padding: 12,
                        fontSize: 21,
                        fontWeight: "bold",
                        color: "#000000",
                        textAlign: "end"
                      }}
                    >
                      Đơn giá
                    </td>
                    <td
                      style={{
                        padding: 12,
                        fontSize: 21,
                        fontWeight: "bold",
                        color: "#000000",
                        textAlign: "end"
                      }}
                    >
                      Chiết khấu
                    </td>
                    <td
                      style={{
                        padding: 12,
                        fontSize: 21,
                        fontWeight: "bold",
                        color: "#000000",
                        textAlign: "end"
                      }}
                    >
                      Thành tiền
                    </td>
                  </tr>
                </thead>
                <tbody>
                  {dataPrint?.map((item: any, index: number) => {
                    return (
                      <tr>
                        <td
                          style={{
                            padding: 12,
                            color: "#000000",
                            textAlign: "center",
                            fontSize: 20,
                            borderBottom: "1px dashed #000000", borderTop: "1px dashed #000000"
                          }}
                        >
                          {index + 1}
                        </td>
                        <td
                          style={{
                            padding: 12,
                            color: "#000000",
                            textAlign: "start",
                            fontSize: 20,
                            borderBottom: "1px dashed #000000", borderTop: "1px dashed #000000",
                            maxWidth: 300
                          }}
                        >
                          {item?.service_id?.name}
                        </td>
                        <td
                          style={{
                            padding: 12,
                            color: "#000000",
                            textAlign: "center",
                            fontSize: 20,
                            borderBottom: "1px dashed #000000", borderTop: "1px dashed #000000"
                          }}
                        >
                          Lần
                        </td>
                        <td
                          style={{
                            padding: 12,
                            color: "#000000",
                            textAlign: "center",
                            fontSize: 20,
                            borderBottom: "1px dashed #000000", borderTop: "1px dashed #000000"
                          }}
                        >
                          {item?.service_quantity}
                        </td>
                        <td
                          style={{
                            padding: 12,
                            color: "#000000",
                            textAlign: "end",
                            fontSize: 20,
                            borderBottom: "1px dashed #000000", borderTop: "1px dashed #000000"
                          }}
                        >
                          {PriceUtils.format(item?.service_id?.price || "--", " đ")}
                        </td>
                        <td
                          style={{
                            padding: 12,
                            color: "#000000",
                            textAlign: "end",
                            fontSize: 20,
                            borderBottom: "1px dashed #000000", borderTop: "1px dashed #000000"
                          }}
                        >
                          {PriceUtils.format(item?.service_discount || "--", " đ")}
                        </td>
                        <td
                          style={{
                            padding: 12,
                            color: "#000000",
                            textAlign: "end",
                            fontSize: 20,
                            borderBottom: "1px dashed #000000", borderTop: "1px dashed #000000"
                          }}
                        >
                          {PriceUtils.format(total || "--", " đ")}
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </Table>
              <div style={{ fontSize: 20 }}>*Chiết khấu được tính trên đơn giá của mỗi dịch vụ</div>
              <tr className="no-border">
                <td
                  style={{
                    padding: 15,
                    color: "#000000",
                    fontSize: 20,
                    width: 350,
                  }}
                >
                  Tổng tiền
                </td>
                <td
                  style={{
                    padding: 15,
                    color: "#000000",
                    textAlign: "end",
                    width: 1100,
                  }}
                >
                  <span style={{ fontSize: 20 }}>
                    {PriceUtils.format(total, " đ")}
                  </span>
                </td>
              </tr>
              <tr className="no-border">
                <td
                  style={{
                    padding: 15,
                    color: "#000000",
                    fontSize: 20,
                    width: 400,
                  }}
                >
                  Chiết khấu gói thẻ dịch vụ <br />
                  {dataInfor?.examination_id?.service_package_id ? `(${dataInfor?.examination_id?.service_package_id?.name})` : null}
                </td>
                <td
                  style={{
                    padding: 15,
                    color: "#000000",
                    textAlign: "end",
                    width: 960,
                  }}
                >
                  <span style={{ fontSize: 20 }}>
                    {PriceUtils.format((dataPrint?.[0]?.partner == null ? total * dataInfor?.examination_id?.service_package_id?.discount_service_examination / 100 : total * dataInfor?.examination_id?.service_package_id?.discount_service_partner_examination / 100) || 0, " đ")}
                  </span>
                </td>
              </tr>
              <tr className="no-border">
                <td
                  style={{
                    padding: 15,
                    color: "#000000",
                    fontWeight: "bold",
                    fontSize: 20,
                    width: 350,
                  }}
                >
                  Tổng tiền thanh toán
                </td>
                <td
                  style={{
                    padding: 15,
                    color: "#000000",
                    textAlign: "end",
                    width: 1100,
                  }}
                >
                  <span style={{ fontSize: 20 }}>
                    {PriceUtils.format(total - ((dataPrint?.[0]?.partner == null ? total * dataInfor?.examination_id?.service_package_id?.discount_service_examination / 100 : total * dataInfor?.examination_id?.service_package_id?.discount_service_partner_examination / 100) || 0), " đ")}
                  </span>
                </td>
              </tr>
              <tr className="no-border">
                <td
                  style={{
                    padding: 15,
                    color: "#000000",
                    fontSize: 20,
                    borderTop: "none",
                    paddingTop: 0,
                    width: 350,
                  }}
                >
                  Số tiền viết bằng chữ
                </td>
                <td
                  style={{
                    padding: 15,
                    color: "#000000",
                    borderTop: "none",
                    paddingTop: 0,
                    textAlign: "end",
                    width: 1100,
                    fontSize: 20,
                    fontStyle: "italic",
                    textTransform: "uppercase"
                  }}
                >
                  {PriceUtils.readMoney((total - ((dataPrint?.[0]?.partner == null ? total * dataInfor?.examination_id?.service_package_id?.discount_service_examination / 100 : total * dataInfor?.examination_id?.service_package_id?.discount_service_partner_examination / 100) || 0)).toString())}
                </td>
              </tr>
            </div>
          </div>
        </div>
        <div className="p-5" style={{ marginTop: 25 }}>
          <Row>
            <Col md={6}>
              <div className="text-center">
                <div
                  className="label font-weight-bold pb-5"
                  style={{ fontSize: 26 }}
                >
                  Khách hàng
                </div>
              </div>
            </Col>
            <Col md={6}>
              <div className="text-center">
                <div
                  className="label font-weight-bold pb-5"
                  style={{ fontSize: 26 }}
                >
                  Thu ngân
                </div>
                <div className="doctor-name mt-5 font-weight-bold">
                  {/* {dataInfor?.created_uid?.name || "---"} */}
                </div>
              </div>
            </Col>
          </Row>
        </div>
        <div style={{ marginTop: 168, marginLeft: 48, marginRight: 48, marginBottom: 15 }}>
          <p className="text-center" style={{ color: "#000000", fontSize: 17 }}>
            Khách hàng vui lòng xuất trình phiếu này trong trường hợp muốn huỷ
            dịch vụ. Phòng khám không giải quyết các trường hợp nếu thiếu các
            giấy tờ trên. Tất cả các dịch vụ đã được bác sĩ tư vấn và thoả thuận
            với khách hàng. Khách hàng kiểm tra lại kỹ bảng kê trước khi thanh
            toán.
          </p>
        </div>
        <div
          style={{ fontStyle: "italic", color: "#000000", textAlign: "center" }}
        >
          <p className="mt-2">Xin cảm ơn Quý Khách đã lựa chọn dịch vụ y tế của chúng tôi!</p>
        </div>
      </div>
    )
  }

  return (
    <div
      className="print-content pre-print"
      style={{ overflow: "hidden" }}
      ref={componentRef}
    >
      <PrintContent />
      <div className="page-break"></div>
      <PrintContent />
    </div>
  );
};

export default List;
